import { useEffect, useRef, useState } from "react";

export default function MultiSelect({
  options = [],
  value = [],
  onChange,
  labelKey = "label",
  valueKey = "value",
  placeholder = "Seleccionar...",
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const toggle = (val) => {
    if (value.includes(val)) {
      onChange(value.filter((v) => v !== val));
    } else {
      onChange([...value, val]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabels = options
    .filter((o) => value.includes(o[valueKey]))
    .map((o) => o[labelKey]);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full p-3 border rounded-lg text-left"
      >
        {selectedLabels.length
          ? selectedLabels.join(", ")
          : placeholder}
      </button>

      {open && (
        <div className="absolute z-10 w-full bg-white border rounded-lg mt-1 max-h-60 overflow-y-auto shadow">
          {options.map((opt) => {
            const val = opt[valueKey];
            const checked = value.includes(val);

            return (
              <div
                key={val}
                onClick={() => toggle(val)}
                className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
              >
                <input type="checkbox" readOnly checked={checked} />
                {opt[labelKey]}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}